<template>
  <va-create-layout :title="title">
    <faqs-form :item="item" />
  </va-create-layout>
</template>

<script>
export default {
  props: ["title", "item"],
};
</script>
